module.exports = __webpack_public_path__ + "img/19.cfb44795.jpg";